/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ActionListModel} from '../model/action-list.model';
import {TableRowAction} from '../model/table-row-action.model';
import {ActionType} from '../model/action-type.enum';

@Component({
  selector: 'well-action-list',
  templateUrl: './action-list.component.html',
  styleUrls: ['./action-list.component.scss']
})
export class ActionListComponent implements OnInit {
  @Input() isAdministrator: boolean | undefined = undefined;
  @Input() list: ActionListModel[] | undefined = undefined;
  @Input() totalSize: number | undefined = undefined;
  @Input() actionNameList: string[] | undefined = undefined;
  @Output() lazyLoad: EventEmitter<any> = new EventEmitter<any>(true);
  @Output()
  rowAction: EventEmitter<TableRowAction> = new EventEmitter<TableRowAction>(true);

  filterDate: any;

  cols: any[] | undefined = undefined;
  selectedName: string | undefined = undefined;

  ngOnInit() {
    this.cols = [
      {field: 'actionName', header: 'company.subscription-type.actions-list.list.name', type: 'name-dropdown'},
      {field: 'actionCost', header: 'company.subscription-type.actions-list.list.cost', type: 'number', filterMatchMode: 'equals'},
      {field: 'validFrom', header: 'company.subscription-type.actions-list.list.validFrom', filterMatchMode: 'gt', type: 'calendar'},
      {field: 'validTo', header: 'company.subscription-type.actions-list.list.validTo', filterMatchMode: 'lt', type: 'calendar'},
      {field: 'monthlyIncludedAmount', header: 'company.subscription-type.actions-list.list.monthlyIncludedAmount', type: 'number', filterMatchMode: 'equals'},
      {field: 'allowExtra', header: 'company.subscription-type.actions-list.list.allowExtra', type: 'boolean'}
    ];
  }

  loadLazy(event: any) {
    this.lazyLoad.emit(event);
  }

  edit(uuid: string) {
    const action = {
      actionType: ActionType.EDIT,
      rowDataUuid: uuid
    };
    this.rowAction.emit(action);
  }

  isExpired(row: ActionListModel): boolean {
    if (!row.validTo) return false;
    const today = new Date().toISOString().slice(0, 10);
    return row.validTo <= today;
  }

}
